import * as ProRegularSvgIcons from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'
import type * as Api from 'src/api'
import { useLocale } from 'src/hooks/locale/locale'
import { useTranslatable } from 'src/hooks/locale/utils'
import { useTheme } from 'src/state/providers/Theme'

const MEDICINE_DEGREE: Api.StudentDegree = 'STUDENT_ONE_STAGE_HIGHER'
// The reference is issued to graduates only, so it is offered for the same students the
// API considers eligible: medicine students whose status is "კურსდამთავრებული სტუდენტი".
const GRADUATED_EDU_STATUS = '6'

export default function ClinicalInternshipReferenceButton({
  user,
  studentProfile,
  semId,
}: {
  readonly user: Api.AdministratorUser
  readonly studentProfile: Api.UserProfileStudent
  readonly semId: string
}): JSX.Element | null {
  const t = useTranslatable()
  const theme = useTheme()
  const locale = useLocale()

  if (studentProfile.degree !== MEDICINE_DEGREE || studentProfile.eduStatus !== GRADUATED_EDU_STATUS) return null

  const tooltipId = `${user.id}-clinicalInternshipReferenceTooltip`
  const search = semId !== '' ? `?semId=${semId}` : ''

  return (
    <>
      <Tooltip id={tooltipId} place="top" variant={theme === 'dark' ? 'dark' : 'light'} className="mb-1 p-1">
        {t('reference:clinical_internship')}
      </Tooltip>
      <Link
        to={`/${locale}/administrator/users/students/${user.uid}/${studentProfile.id}/reference/clinical-internship${search}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex rounded-[18px] p-[10px] text-xs"
        data-tooltip-id={tooltipId}
        data-testid="clinicalInternshipReferenceButton"
      >
        <span className="w-[18px]">
          <FontAwesomeIcon icon={ProRegularSvgIcons.faFileCertificate} />
        </span>
      </Link>
    </>
  )
}
